// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3GpJO","title":"ClientInsurance_title__2osfP","itemText":"ClientInsurance_itemText__2-q33"};